import React from 'react';

const SuspenseLoading = () => {
    return (
        <div className={`loading-indicator-wrapper`}>
            <span className={`loading-indicator`}/>
        </div>
    )
}

export default SuspenseLoading;